export default {
    'AFFILIATE': 'AFFILIATE', 
    'ADMIN': 'ADMIN', 
    'SELLER': 'SELLER',
    'EMPLOYEE':'EMPLOYEE',
    'MODERATOR': "MODERATOR",
    "FULFILLMENT":"FULFILLMENT"
};